export class PlaceListPalletDto {
    storeConsumptionId: number;
    rackPosition: number;
    palletCode: number;
    constructor(storeConsumptionId: number,rackPosition: number,palletCode: number){
        this.storeConsumptionId = storeConsumptionId
        this.rackPosition = rackPosition
        this.palletCode = palletCode
    }
}